angular.module('Itao.IndicatorMap').controller('BookmarkModalController', ['$scope', '$uibModalInstance', 'data', function($scope, $uibModalInstance, data) {
  'use strict';
  // Apply categories to scope for select field
  $scope.categories = data.categories;

  $scope.newBookmark = {};

  /**
   * Closes the creation modal window
   */
  $scope.close = function () {
    $uibModalInstance.dismiss('cancel');
  };

  /**
   * Closes the modal window and returns the data for the new bookmark
   * @param {object} newBookmark object consisting of title and category id
   */
  $scope.create = function (newBookmark) {
    $uibModalInstance.close(newBookmark);
  };

}]);
